// Simple i18n implementation for Vietnamese, English, Korean

const translations = {
  vi: {
    // Common
    hello: 'Xin chào',
    loading: 'Đang tải...',
    save: 'Lưu',
    cancel: 'Hủy',
    delete: 'Xóa',
    edit: 'Sửa',
    add: 'Thêm',
    search: 'Tìm kiếm',
    filter: 'Lọc',
    close: 'Đóng',
    confirm: 'Xác nhận',
    back: 'Quay lại',
    next: 'Tiếp tục',
    submit: 'Gửi',
    saveDraft: 'Lưu tạm',
    success: 'Thành công',
    error: 'Lỗi',

    // Auth
    login: 'Đăng nhập',
    logout: 'Đăng xuất',
    username: 'Tên đăng nhập',
    password: 'Mật khẩu',
    changePassword: 'Đổi mật khẩu',

    // Bottom Nav
    home: 'Trang chủ',
    work: 'Công việc',
    notifications: 'Thông báo',
    settings: 'Cài đặt',
    profile: 'Cá nhân',

    // Profile Page
    accountInfo: 'Thông tin tài khoản',
    fullName: 'Họ và tên',
    email: 'Email',
    phone: 'Số điện thoại',
    userType: 'Loại tài khoản',
    joinDate: 'Ngày tham gia',
    actions: 'Hành động',
    language: 'Ngôn ngữ',
    logout: 'Đăng xuất',
    confirmLogout: 'Bạn có chắc muốn đăng xuất?',
    collaborator: 'Cộng tác viên',
    administrator: 'Quản trị viên',
    user: 'Người dùng',
    selectLanguage: 'Chọn ngôn ngữ',
    notificationEnabled: 'Đã bật thông báo',
    notificationEnabledBody: 'Bạn sẽ nhận được thông báo từ ứng dụng',
    pleaseSelectImageFile: 'Vui lòng chọn file ảnh',
    updateSuccessful: 'Cập nhật thành công',
    avatarUpdated: 'Ảnh đại diện đã được cập nhật',

    // Services
    loanService: 'Vay Tín Dụng',
    studyAbroadService: 'Du Học',
    creditCardService: 'Thẻ Tín Dụng',
    visaService: 'Đổi Visa',
    simService: 'Đăng Ký SIM',
    phoneService: 'Mua Điện Thoại',
    flightService: 'Vé Máy Bay',
    comingSoon: 'Sắp tới',
    active: 'Đang làm',

    // Info page
    info: 'Thông tin',
    infoDocuments: 'Tài liệu',

    // Dashboard
    commissionThisMonth: 'Hoa hồng tháng này',
    newCustomers: 'Khách hàng mới',
    totalLoans: 'Tổng hồ sơ',
    approvedLoans: 'Đã duyệt',
    approvalRate: 'Tỷ lệ duyệt',

    // Customer
    customers: 'Khách hàng',
    customerName: 'Tên khách hàng',
    phone: 'Số điện thoại',
    email: 'Email',
    address: 'Địa chỉ',
    idNumber: 'Số CMND/CCCD',
    idType: 'Loại giấy tờ',
    dateOfBirth: 'Ngày sinh',
    country: 'Quốc gia',
    notes: 'Ghi chú',

    // Loan
    createLoan: 'Tạo hồ sơ vay',
    loanList: 'Danh sách hồ sơ',
    loanDetails: 'Chi tiết khoản vay',
    loanAmount: 'Số tiền vay',
    loanTerm: 'Kỳ hạn',
    months: 'tháng',
    bank: 'Ngân hàng',
    branch: 'Chi nhánh',
    interestPaymentDate: 'Ngày trả lãi',
    principalPaymentDate: 'Ngày trả gốc',
    status: 'Trạng thái',

    // Loan statuses
    pending: 'Chờ Duyệt',
    approved: 'Tiếp Nhận',
    rejected: 'Từ chối',
    disbursed: 'Đã giải ngân',
    repaying: 'Đang trả nợ',
    completed: 'Hoàn thành',
    draft: 'Tạm lưu',

    // Commission
    commission: 'Hoa hồng',
    commissionDetails: 'Chi tiết hoa hồng',
    totalCommission: 'Tổng hoa hồng',
    earned: 'Đã tính',
    pending: 'Chờ giải ngân',
    clawback: 'Thu hồi',
    paymentRequest: 'Yêu cầu thanh toán',
    requestPayment: 'Yêu cầu thanh toán',

    // Notifications
    newLoanApproved: 'Hồ sơ được duyệt',
    loanRejected: 'Hồ sơ bị từ chối',
    loanDisbursed: 'Đã giải ngân',
    commissionPaid: 'Hoa hồng đã chi trả',
    clawbackNotice: 'Cảnh báo thu hồi',
    noNotifications: 'Không có thông báo',
    markAllRead: 'Đánh dấu đã đọc',
    all: 'Tất cả',
    unread: 'Chưa đọc',
    read: 'Đã đọc',
    justNow: 'Vừa xong',
    minutesAgo: 'phút trước',
    hoursAgo: 'giờ trước',
    daysAgo: 'ngày trước',

    // Login
    loginTitle: 'Link To KMO',
    loginSubtitle: 'Đăng nhập để tiếp tục',
    emailOrPhonePlaceholder: 'Email hoặc số điện thoại',
    rememberMe: 'Duy trì đăng nhập',
    loggingIn: 'Đang đăng nhập...',
    contactAdmin: 'Liên hệ quản lý nếu bạn quên mật khẩu',
    or: 'hoặc',
    loginWithKakao: 'Tiếp tục với Kakao',
    processingKakaoLogin: 'Đang xử lý đăng nhập Kakao...',
    pleaseWait: 'Vui lòng đợi...',
    loginSuccessful: 'Đăng nhập thành công!',
    redirectingToHome: 'Đang chuyển về trang chủ...',
    loginFailed: 'Đăng nhập thất bại',
    redirectingToLogin: 'Đang quay về trang đăng nhập...',

    // Work Page
    createNewLoan: 'Tạo hồ sơ vay',
    createNewLoanDesc: 'Tạo hồ sơ vay mới cho khách hàng',
    loanListDesc: 'Xem hồ sơ đã gửi và tạm lưu',
    customersDesc: 'Quản lý khách hàng của bạn',
    commissionDesc: 'Xem hoa hồng và yêu cầu thanh toán',
    quickOverview: 'Tổng quan nhanh',
    draftLoans: 'Hồ sơ tạm lưu',
    pendingApproval: 'Chờ duyệt',
    disbursedLoans: 'Đã giải ngân',

    // Loan Form
    editLoan: 'Chỉnh sửa hồ sơ',
    createNewLoanTitle: 'Tạo hồ sơ vay mới',
    uploadDocuments: 'Upload giấy tờ',
    selectBank: 'Chọn ngân hàng',
    loanAmountStep: 'Số tiền vay',
    loanTermStep: 'Kỳ hạn',
    paymentDates: 'Ngày trả nợ',
    customerInfo: 'Thông tin khách hàng',
    notesStep: 'Ghi chú',
    continue: 'Tiếp tục',
    savingDraft: 'Đang lưu...',
    sending: 'Đang gửi...',
    sendLoan: 'Gửi hồ sơ',
    incompleteStep: 'Chưa hoàn thành',
    scrollDown: 'Cuộn xuống để xem tất cả',
    fillAllFields: 'Vui lòng điền đầy đủ thông tin trước khi tiếp tục',
    checkInfo: 'Vui lòng kiểm tra lại thông tin',
    confirmSend: 'Bạn có chắc muốn gửi hồ sơ này?',
    draftSaved: 'Đã cập nhật hồ sơ tạm lưu!',
    draftSavedNew: 'Đã lưu hồ sơ tạm!',
    loanSentSuccess: 'Gửi hồ sơ thành công! Hồ sơ đang chờ admin duyệt.',
    errorOccurred: 'Có lỗi xảy ra. Vui lòng thử lại!',

    // Loan List
    loanRecords: 'Hồ sơ vay',
    createNew: 'Tạo mới',
    submitted: 'Đã gửi',
    noLoansSubmitted: 'Chưa có hồ sơ nào được gửi',
    noDrafts: 'Chưa có hồ sơ tạm lưu',
    loanCode: 'Hồ sơ',
    rejectionReason: 'Lý do',
    confirmDeleteDraft: 'Xác nhận xóa',
    deleteDraftMessage: 'Bạn có chắc muốn xóa hồ sơ tạm lưu này?',
    draftDeletedSuccessfully: 'Đã xóa hồ sơ tạm lưu thành công',

    // Loan Detail
    loanDetail: 'Chi tiết hồ sơ',
    statusLabel: 'Trạng thái',
    customerInfoSection: 'Thông tin khách hàng',
    fullName: 'Họ tên',
    bankInfoSection: 'Thông tin ngân hàng',
    loanInfoSection: 'Thông tin khoản vay',
    createdDate: 'Ngày tạo',
    disbursedDate: 'Ngày giải ngân',
    paymentSchedule: 'Lịch trả nợ',
    scheduleAfterDisburse: 'Lịch trả nợ sẽ được tạo sau khi giải ngân',
    totalPrincipal: 'Tổng gốc',
    totalInterest: 'Tổng lãi',
    paidPeriods: 'Đã trả',
    period: 'Kỳ',
    principal: 'Gốc',
    interest: 'Lãi',
    total: 'Tổng',
    paymentPeriod: 'Kỳ hạn thanh toán',
    expectedInterest: 'Tiền lãi dự kiến thanh toán',
    interestPayment: 'Tiền lãi dự kiến thanh toán',
    principalPayment: 'Số tiền gốc thanh toán',
    totalPayment: 'Số gốc và lãi thanh toán',
    remainingBalance: 'Số dư nợ sau khi thanh toán',
    paid: 'Đã trả',
    unpaid: 'Chưa trả',
    notFound: 'Không tìm thấy hồ sơ',
    backToList: 'Quay lại danh sách',

    // Customer
    addCustomer: 'Tạo khách hàng mới',
    editCustomer: 'Sửa khách hàng',
    searchCustomer: 'Tìm theo tên, SĐT, CCCD...',
    noCustomersFound: 'Không tìm thấy khách hàng',
    noCustomersYet: 'Chưa có khách hàng nào. Tạo khách hàng mới để bắt đầu!',
    personalInfo: 'Thông tin cá nhân',
    idTypeLabel: 'Loại giấy tờ',
    idNumberLabel: 'Số giấy tờ',
    dateOfBirthLabel: 'Ngày sinh',
    gender: 'Giới tính',
    male: 'Nam',
    female: 'Nữ',
    other: 'Khác',
    addressSection: 'Địa chỉ',
    notesSection: 'Ghi chú',
    deleteCustomer: 'Bạn có chắc muốn xóa khách hàng này?',
    deleting: 'Đang xóa...',
    updating: 'Đang cập nhật...',
    creating: 'Đang tạo...',
    update: 'Cập nhật',
    create: 'Tạo mới',
    customerUpdated: 'Cập nhật khách hàng thành công!',
    customerCreated: 'Tạo khách hàng thành công!',
    customerDeleted: 'Xóa khách hàng thành công!',
    cannotDelete: 'Không thể xóa khách hàng. Vui lòng thử lại!',
    enterName: 'Vui lòng nhập họ tên',
    enterIdNumber: 'Vui lòng nhập số CMND/CCCD',
    enterPhone: 'Vui lòng nhập số điện thoại',
    invalidPhone: 'Số điện thoại không hợp lệ',
    invalidEmail: 'Email không hợp lệ',
    cannotLoadCustomer: 'Không thể tải thông tin khách hàng',

    // Commission
    commissionPage: 'Hoa hồng',
    selectPeriod: 'Chọn kỳ',
    month: 'Tháng',
    totalEarned: 'Tổng thu nhập',
    totalClawback: 'Thu hồi',
    totalPaid: 'Đã thanh toán',
    netAmount: 'Thực nhận',
    commissionsEarned: 'Hoa hồng đã tính',
    clawbacks: 'Thu hồi',
    noCommissionThisMonth: 'Chưa có hoa hồng nào trong tháng này',
    commissionPercent: 'Tỷ lệ',
    originalCommission: 'Hoa hồng gốc',
    clawbackReason: 'Lý do thu hồi',
    loadingCommission: 'Đang tải hoa hồng...',

    // Payment Request
    paymentRequestTitle: 'Yêu cầu thanh toán',
    currentMonthCommission: 'Hoa hồng tháng',
    totalReceivable: 'Số dư còn lại có thể rút',
    availableBalance: 'Số dư còn lại có thể rút',
    createPaymentRequest: 'Tạo yêu cầu thanh toán',
    withdrawalAmount: 'Số dư hiện tại',
    withdrawalAmountLabel: 'Số tiền rút',
    bankName: 'Tên ngân hàng',
    accountNumber: 'Số tài khoản',
    accountHolderName: 'Tên chủ tài khoản',
    enterAmount: 'Nhập số tiền',
    enterBankName: 'Nhập tên ngân hàng',
    enterAccountNumber: 'Nhập số tài khoản',
    enterAccountHolderName: 'Nhập tên chủ tài khoản',
    totalAvailable: 'Số tiền được rút',
    requestedAmount: 'Số tiền muốn rút',
    enterRequestedAmount: 'Nhập số tiền muốn rút',
    maxAmount: 'Tối đa',
    invalidWithdrawalAmount: 'Số tiền rút không hợp lệ hoặc vượt quá số dư',
    pleaseCompleteAllFields: 'Vui lòng điền đầy đủ thông tin',
    submitRequest: 'Gửi yêu cầu',
    requestHistory: 'Lịch sử yêu cầu',
    noRequestsYet: 'Bạn chưa có yêu cầu thanh toán nào',
    requestCreated: 'Ngày tạo',
    requestApproved: 'Ngày duyệt',
    requestPaid: 'Ngày thanh toán',
    noCommissionToRequest: 'Không có hoa hồng để yêu cầu thanh toán',
    confirmPaymentRequest: 'Bạn có chắc muốn tạo yêu cầu thanh toán',
    requestSuccess: 'Tạo yêu cầu thanh toán thành công!\nAdmin sẽ xem xét và duyệt trong thời gian sớm nhất.',
    noCommissionYet: 'Chưa có hoa hồng trong tháng này',
    negativeCommission: 'Hoa hồng bị âm do thu hồi. Không thể tạo yêu cầu.',
    note: 'Lưu ý',
    noteItem1: 'Yêu cầu thanh toán sẽ được admin xem xét trong vòng 3-5 ngày làm việc',
    noteItem2: 'Hoa hồng sẽ được chuyển vào tài khoản đã đăng ký sau khi duyệt',
    noteItem3: 'Nếu có thu hồi, số tiền sẽ được trừ tự động vào tổng thanh toán',
    noteItem4: 'Bạn có thể xem chi tiết hoa hồng tại trang "Hoa hồng"',

    // HomePage
    recentActivity: 'Hoạt động gần đây',
    newCustomersCount: 'Khách hàng mới',
    approvedCount: 'Đã duyệt',
    loanRecordsLabel: 'Hồ sơ',
    commissionLabel: 'Hoa hồng',
    customersLabel: 'Khách hàng',

    // Step Components
    uploadFiles: 'Upload giấy tờ',
    clickOrDrag: 'Click để chọn file hoặc kéo thả vào đây',
    supportedFormats: 'Hỗ trợ: JPG, PNG, PDF (tối đa 10MB/file)',
    uploading: 'Đang upload...',
    uploadFailed: 'Upload thất bại. Vui lòng thử lại!',
    selectFromList: 'Chọn từ danh sách',
    enterManually: 'Nhập thủ công',
    selected: 'Đã chọn',
    selectCountry: 'Chọn quốc gia',
    vietnam: 'Việt Nam',
    southKorea: 'Hàn Quốc (South Korea)',
    selectVisaType: 'Chọn loại visa',
    visaE9: 'E9 - Lao động phổ thông',
    visaE7: 'E7 - Lao động kỹ năng đặc biệt',
    visaF4: 'F4 - Đồng bào',
    visaF5: 'F5 - Thường trú',
    fillRequired: 'Vui lòng điền đầy đủ thông tin bắt buộc (tên, SĐT, quốc gia, loại visa)',
    searchByNamePhone: 'Tìm theo tên, SĐT...',
    enterManuallyBtn: 'Nhập thủ công',
    fullNameLabel: 'Họ và tên',
    phoneLabel: 'Số điện thoại',
    emailLabel: 'Email',
    idNumberLabel: 'Số CCCD/CMND',
    countryLabel: 'Quốc gia',
    visaTypeLabel: 'Loại visa',
    namePlaceholder: 'Nguyễn Văn A',
    phonePlaceholder: '+84 912 345 678',
    emailPlaceholder: 'email@example.com',
    idPlaceholder: '001234567890',
    selectVisaTypePlaceholder: 'Chọn loại visa',
    countryUSA: 'Mỹ (USA)',
    countryChina: 'Trung Quốc (China)',
    countryJapan: 'Nhật Bản (Japan)',
    countryThailand: 'Thái Lan (Thailand)',
    countryPhilippines: 'Philippines',
    countryIndonesia: 'Indonesia',
    countryMalaysia: 'Malaysia',
    countrySingapore: 'Singapore',
    countryOther: 'Khác (Other)',
    visaH2: 'H2 - Visa du lịch/nghỉ dưỡng',
    visaF6: 'F6 - Visa kết hôn',
    visaD2: 'D2 - Visa du học',
    visaD10: 'D10 - Visa tìm việc',
    visaCitizen: 'Công dân Hàn Quốc',
    visaOther: 'Khác',
    paymentDateMonthly: 'Ngày trả nợ hàng tháng',
    notePaymentDate: 'Lưu ý',
    notePaymentDateItem1: 'Chọn ngày trả nợ phù hợp với khả năng tài chính của khách hàng',
    notePaymentDateItem2: 'Các ngày phổ biến: 5, 10, 15, 20, 25 hàng tháng',
    selectPaymentDate: 'Vui lòng chọn ngày trả nợ để tiếp tục',
    loanSummary: 'Tóm tắt hồ sơ',
    customerLabel: 'Khách hàng',
    phoneLabel: 'Số điện thoại',
    idLabel: 'CCCD',
    bankLabel: 'Ngân hàng',
    branchLabel: 'Chi nhánh',
    loanAmountLabel: 'Số tiền vay',
    termLabel: 'Kỳ hạn',
    interestDateLabel: 'Ngày trả lãi',
    principalDateLabel: 'Ngày trả gốc',
    dayOfMonth: 'Ngày',
    monthly: 'hàng tháng',
    notEntered: 'Chưa nhập',
    notSelected: 'Chưa chọn',
    notesOptional: 'Ghi chú (không bắt buộc)',
    notesPlaceholder: 'Thêm ghi chú về khách hàng, điều kiện vay, hoặc thông tin khác...',
    notesExample: 'Ví dụ: Khách hàng có nhu cầu vay gấp, thu nhập ổn định, đã vay 1 lần trước đó...',
    loanComplete: 'Hồ sơ đã đầy đủ thông tin! Bạn có thể lưu tạm hoặc gửi ngay.',
    noCustomerFound: 'Không tìm thấy khách hàng',
    documentsAttached: 'Tài liệu đính kèm',
    fileCount: 'file',
    estimatedCommissionLabel: 'Hoa hồng dự kiến',
    estimatedPercent: '(Ước tính 2%)',

    // Coming Soon Page
    comingSoonTitle: 'Sắp Ra Mắt',
    comingSoonDescription: 'Tính năng này đang được phát triển. Vui lòng liên hệ quản trị viên để biết thêm thông tin.',
    contactUs: 'Liên Hệ',
    chatViaKakao: 'Chat qua KakaoTalk',
    callAdmin: 'Gọi điện',
    backToHome: 'Quay về Trang chủ',

    // Settings Page
    logoutConfirm: 'Đăng xuất?',
    ctvRole: 'Cộng tác viên (CTV)',
    userCode: 'Mã',
    accountSection: 'Tài khoản',
    appSection: 'Ứng dụng',
    languageLabel: 'Ngôn ngữ',
    selectLanguage: 'Chọn ngôn ngữ',
    appVersion: 'Phiên bản',
    appCopyright: '© 2024 CTV Tín Dụng',
    notificationEnabled: 'Thông báo đã bật',
    notificationEnabledBody: 'Bạn sẽ nhận được thông báo về các cập nhật mới',
    support: 'Hỗ trợ',
    contactViaKakao: 'Liên hệ qua Kakao',

    // Step2 Bank
    selectBank: 'Chọn ngân hàng',
    selectBranch: 'Chọn chi nhánh',
    searchBank: 'Tìm ngân hàng...',
    searchBranch: 'Tìm chi nhánh...',
    pleaseSelectBank: 'Vui lòng chọn ngân hàng để tiếp tục',
    pleaseSelectBranch: 'Vui lòng chọn chi nhánh để tiếp tục',
    bankSelected: 'Đã chọn ngân hàng',
    noBranchesAvailable: 'Không có chi nhánh',
    bankAndBranchSelected: 'Đã chọn ngân hàng và chi nhánh',
    noBanksFound: 'Không tìm thấy ngân hàng',
    noBranchesFound: 'Không tìm thấy chi nhánh',
    skipBranchSelection: 'Bỏ qua (Không có chi nhánh)',

    // Step3 Amount
    loanAmountInput: 'Số tiền vay',
    quickSelect: 'Chọn nhanh',
    estimatedCommission: 'Hoa hồng ước tính',
    monthlyFixed: 'Hoa hồng cố định hàng tháng - tùy theo cài đặt admin',
    minimumLoan: 'Số tiền vay tối thiểu',
    million: 'triệu',

    // Step4 Term
    termLabel: 'Kỳ hạn',
    monthsLabel: 'tháng',
    feeRate: 'Tỷ lệ phí',
    noteLabel: 'Ghi chú',
    estimatedFee: 'Phí ước tính',
    estimatedMonthlyPayment: 'Thanh toán hàng tháng ước tính',
    basedOnInterestRate: 'Dựa trên lãi suất ước tính 12%/năm',
    pleaseEnterTerm: 'Vui lòng nhập kỳ hạn vay',

    // Step5 Dates
    selectDate: 'Chọn ngày...',
    dayOfMonthLabel: 'Ngày {day} hàng tháng',
    popularDays: 'Ngày phổ biến',
    dayLabel: 'Ngày {day}',

    // Loan Increase Request Modal
    loanIncreaseRequestTitle: 'Yêu cầu thay đổi hồ sơ vay',
    changeMultipleHint: 'Bạn có thể thay đổi một hoặc nhiều mục cùng lúc',
    changeTypeLabel: 'Loại thay đổi',
    changeTypeAmount: 'Thay đổi số tiền vay',
    changeTypeTerm: 'Thay đổi kỳ hạn vay',
    changeTypePaymentDate: 'Thay đổi ngày trả lãi',
    loanCodeLabel: 'Mã hồ sơ',

    // Amount change
    currentAmountLabel: 'Số tiền hiện tại',
    newAmountLabel: 'Số tiền vay mới yêu cầu',
    newAmountPlaceholder: 'Nhập số tiền vay mới',
    increaseLabel: 'Tăng thêm',
    decreaseLabel: 'Giảm đi',

    // Term change
    currentTermLabel: 'Kỳ hạn hiện tại',
    newTermLabel: 'Kỳ hạn mới yêu cầu',
    newTermPlaceholder: 'Nhập kỳ hạn mới',
    termUnit: 'tháng',
    termChange: 'Thay đổi',

    // Payment date change
    currentPaymentDateLabel: 'Ngày trả lãi hiện tại',
    newPaymentDateLabel: 'Ngày trả lãi mới',
    newPaymentDatePlaceholder: 'Nhập ngày (1-28)',
    paymentDateChange: 'Thay đổi',

    reasonLabel: 'Lý do (không bắt buộc)',
    reasonPlaceholder: 'Mô tả lý do cần thay đổi...',
    submitting: 'Đang gửi...',
    submitRequest: 'Gửi yêu cầu',
    errorAtLeastOneChange: 'Phải có ít nhất một thay đổi',
    errorAmountMustDiffer: 'Số tiền yêu cầu phải khác số tiền hiện tại',
    errorTermMustDiffer: 'Kỳ hạn yêu cầu phải khác kỳ hạn hiện tại',
    errorPaymentDateMustDiffer: 'Ngày trả lãi yêu cầu phải khác ngày hiện tại',
    errorPaymentDateRange: 'Ngày trả lãi phải từ 1 đến 28',
    errorCannotSubmit: 'Không thể gửi yêu cầu. Vui lòng thử lại.',

    // Loan Increase Request List
    increaseRequestHistory: 'Lịch sử yêu cầu thay đổi',
    requestedAmountLabel: 'Số tiền yêu cầu',
    rejectionReasonLabel: 'Lý do từ chối',
    approvedAtLabel: 'Tiếp nhận lúc',
    statusPending: 'Chờ duyệt',
    statusApproved: 'Đã tiếp nhận',
    statusRejected: 'Từ chối',

    // Loan Increase Request - Buttons & Success
    requestLoanChange: 'Yêu cầu thay đổi hồ sơ',
    changeRequestSuccess: 'Yêu cầu thay đổi đã được gửi thành công!',
  },

  en: {
    // Common
    hello: 'Hello',
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    filter: 'Filter',
    close: 'Close',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    saveDraft: 'Save Draft',
    success: 'Success',
    error: 'Error',

    // Auth
    login: 'Login',
    logout: 'Logout',
    username: 'Username',
    password: 'Password',
    changePassword: 'Change Password',

    // Bottom Nav
    home: 'Home',
    work: 'Work',
    notifications: 'Notifications',
    settings: 'Settings',
    profile: 'Profile',

    // Profile Page
    accountInfo: 'Account Information',
    fullName: 'Full Name',
    email: 'Email',
    phone: 'Phone',
    userType: 'Account Type',
    joinDate: 'Join Date',
    actions: 'Actions',
    language: 'Language',
    confirmLogout: 'Are you sure you want to logout?',
    collaborator: 'Collaborator',
    administrator: 'Administrator',
    user: 'User',
    selectLanguage: 'Select Language',
    notificationEnabled: 'Notifications Enabled',
    notificationEnabledBody: 'You will receive notifications from the app',
    pleaseSelectImageFile: 'Please select an image file',
    updateSuccessful: 'Updated successfully',
    avatarUpdated: 'Avatar updated',

    // Services
    loanService: 'Credit Loan',
    studyAbroadService: 'Study Abroad',
    creditCardService: 'Credit Card',
    visaService: 'Visa Service',
    simService: 'SIM Registration',
    phoneService: 'Buy Phone',
    flightService: 'Flight Tickets',
    comingSoon: 'Coming Soon',
    active: 'Active',

    // Info page
    info: 'Information',
    infoDocuments: 'Documents',

    // Dashboard
    commissionThisMonth: 'Commission This Month',
    newCustomers: 'New Customers',
    totalLoans: 'Total Loans',
    approvedLoans: 'Approved',
    approvalRate: 'Approval Rate',

    // Customer
    customers: 'Customers',
    customerName: 'Customer Name',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    idNumber: 'ID Number',
    idType: 'ID Type',
    dateOfBirth: 'Date of Birth',
    country: 'Country',
    notes: 'Notes',

    // Loan
    createLoan: 'Create Loan',
    loanList: 'Loan List',
    loanDetails: 'Loan Details',
    loanAmount: 'Loan Amount',
    loanTerm: 'Loan Term',
    months: 'months',
    bank: 'Bank',
    branch: 'Branch',
    interestPaymentDate: 'Interest Payment Date',
    principalPaymentDate: 'Principal Payment Date',
    status: 'Status',

    // Loan statuses
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    disbursed: 'Disbursed',
    repaying: 'Repaying',
    completed: 'Completed',
    draft: 'Draft',

    // Commission
    commission: 'Commission',
    commissionDetails: 'Commission Details',
    totalCommission: 'Total Commission',
    earned: 'Earned',
    pending: 'Pending',
    clawback: 'Clawback',
    paymentRequest: 'Payment Request',
    requestPayment: 'Request Payment',

    // Notifications
    newLoanApproved: 'Loan Approved',
    loanRejected: 'Loan Rejected',
    loanDisbursed: 'Loan Disbursed',
    commissionPaid: 'Commission Paid',
    clawbackNotice: 'Clawback Notice',
    noNotifications: 'No notifications',
    markAllRead: 'Mark all as read',
    all: 'All',
    unread: 'Unread',
    read: 'Read',
    justNow: 'Just now',
    minutesAgo: 'minutes ago',
    hoursAgo: 'hours ago',
    daysAgo: 'days ago',

    // Login
    loginTitle: 'Link To KMO',
    loginSubtitle: 'Login to continue',
    emailOrPhonePlaceholder: 'Email or phone number',
    rememberMe: 'Remember me',
    loggingIn: 'Logging in...',
    contactAdmin: 'Contact admin if you forgot your password',

    // Work Page
    createNewLoan: 'Create Loan',
    createNewLoanDesc: 'Create new loan application for customer',
    loanListDesc: 'View submitted and draft applications',
    customersDesc: 'Manage your customers',
    commissionDesc: 'View commission and request payment',
    quickOverview: 'Quick Overview',
    draftLoans: 'Draft Loans',
    pendingApproval: 'Pending Approval',
    disbursedLoans: 'Disbursed',

    // Loan Form
    editLoan: 'Edit Loan',
    createNewLoanTitle: 'Create New Loan',
    uploadDocuments: 'Upload Documents',
    selectBank: 'Select Bank',
    loanAmountStep: 'Loan Amount',
    loanTermStep: 'Loan Term',
    paymentDates: 'Payment Dates',
    customerInfo: 'Customer',
    notesStep: 'Notes',
    continue: 'Continue',
    savingDraft: 'Saving...',
    sending: 'Sending...',
    sendLoan: 'Send Loan',
    incompleteStep: 'Incomplete',
    scrollDown: 'Scroll down to see all',
    fillAllFields: 'Please fill all required fields before continuing',
    checkInfo: 'Please check the information',
    confirmSend: 'Are you sure you want to submit this loan?',
    draftSaved: 'Draft updated successfully!',
    draftSavedNew: 'Draft saved!',
    loanSentSuccess: 'Loan submitted successfully! Waiting for admin approval.',
    errorOccurred: 'An error occurred. Please try again!',

    // Loan List
    loanRecords: 'Loan Records',
    createNew: 'Create New',
    submitted: 'Submitted',
    noLoansSubmitted: 'No loans submitted yet',
    noDrafts: 'No draft loans',
    loanCode: 'Loan',
    rejectionReason: 'Reason',
    confirmDeleteDraft: 'Confirm Delete',
    deleteDraftMessage: 'Are you sure you want to delete this draft?',
    draftDeletedSuccessfully: 'Draft deleted successfully',

    // Loan Detail
    loanDetail: 'Loan Details',
    statusLabel: 'Status',
    customerInfoSection: 'Customer Information',
    fullName: 'Full Name',
    bankInfoSection: 'Bank Information',
    loanInfoSection: 'Loan Information',
    createdDate: 'Created Date',
    disbursedDate: 'Disbursed Date',
    paymentSchedule: 'Payment Schedule',
    scheduleAfterDisburse: 'Payment schedule will be created after disbursement',
    totalPrincipal: 'Total Principal',
    totalInterest: 'Total Interest',
    paidPeriods: 'Paid',
    period: 'Period',
    principal: 'Principal',
    interest: 'Interest',
    total: 'Total',
    paymentPeriod: 'Payment Period',
    expectedInterest: 'Expected Interest Payment',
    interestPayment: 'Expected Interest Payment',
    principalPayment: 'Principal Payment',
    totalPayment: 'Total Payment (Principal + Interest)',
    remainingBalance: 'Remaining Balance After Payment',
    paid: 'Paid',
    unpaid: 'Unpaid',
    notFound: 'Loan not found',
    backToList: 'Back to list',

    // Customer
    addCustomer: 'Add New Customer',
    editCustomer: 'Edit Customer',
    searchCustomer: 'Search by name, phone, ID...',
    noCustomersFound: 'No customers found',
    noCustomersYet: 'No customers yet. Create a new customer to get started!',
    personalInfo: 'Personal Information',
    idTypeLabel: 'ID Type',
    idNumberLabel: 'ID Number',
    dateOfBirthLabel: 'Date of Birth',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    addressSection: 'Address',
    notesSection: 'Notes',
    deleteCustomer: 'Are you sure you want to delete this customer?',
    deleting: 'Deleting...',
    updating: 'Updating...',
    creating: 'Creating...',
    update: 'Update',
    create: 'Create',
    customerUpdated: 'Customer updated successfully!',
    customerCreated: 'Customer created successfully!',
    customerDeleted: 'Customer deleted successfully!',
    cannotDelete: 'Cannot delete customer. Please try again!',
    enterName: 'Please enter full name',
    enterIdNumber: 'Please enter ID number',
    enterPhone: 'Please enter phone number',
    invalidPhone: 'Invalid phone number',
    invalidEmail: 'Invalid email',
    cannotLoadCustomer: 'Cannot load customer information',

    // Commission
    commissionPage: 'Commission',
    selectPeriod: 'Select Period',
    month: 'Month',
    totalEarned: 'Total Earned',
    totalClawback: 'Clawback',
    totalPaid: 'Total Paid',
    netAmount: 'Net Amount',
    commissionsEarned: 'Commissions Earned',
    clawbacks: 'Clawbacks',
    noCommissionThisMonth: 'No commission this month',
    commissionPercent: 'Rate',
    originalCommission: 'Original Commission',
    clawbackReason: 'Clawback Reason',
    loadingCommission: 'Loading commission...',

    // Payment Request
    paymentRequestTitle: 'Payment Request',
    currentMonthCommission: 'Commission for',
    totalReceivable: 'Total Receivable',
    createPaymentRequest: 'Create Payment Request',
    withdrawalAmount: 'Current Balance',
    withdrawalAmountLabel: 'Withdrawal Amount',
    bankName: 'Bank Name',
    accountNumber: 'Account Number',
    accountHolderName: 'Account Holder Name',
    enterAmount: 'Enter amount',
    enterBankName: 'Enter bank name',
    enterAccountNumber: 'Enter account number',
    enterAccountHolderName: 'Enter account holder name',
    totalAvailable: 'Total Available',
    requestedAmount: 'Requested Amount',
    enterRequestedAmount: 'Enter requested amount',
    maxAmount: 'Maximum',
    invalidWithdrawalAmount: 'Invalid withdrawal amount or exceeds balance',
    pleaseCompleteAllFields: 'Please complete all fields',
    submitRequest: 'Submit Request',
    requestHistory: 'Request History',
    noRequestsYet: 'No payment requests yet',
    requestCreated: 'Created',
    requestApproved: 'Approved',
    requestPaid: 'Paid',
    noCommissionToRequest: 'No commission to request payment',
    confirmPaymentRequest: 'Are you sure you want to create payment request for',
    requestSuccess: 'Payment request created successfully!\nAdmin will review and approve soon.',
    noCommissionYet: 'No commission this month',
    negativeCommission: 'Negative commission due to clawback. Cannot create request.',
    note: 'Note',
    noteItem1: 'Payment requests will be reviewed by admin within 3-5 business days',
    noteItem2: 'Commission will be transferred to your registered account after approval',
    noteItem3: 'If there are clawbacks, the amount will be automatically deducted',
    noteItem4: 'You can view commission details on the "Commission" page',

    // HomePage
    recentActivity: 'Recent Activity',
    newCustomersCount: 'New Customers',
    approvedCount: 'Approved',
    loanRecordsLabel: 'Loans',
    commissionLabel: 'Commission',
    customersLabel: 'Customers',

    // Step Components
    uploadFiles: 'Upload Documents',
    clickOrDrag: 'Click to select files or drag and drop here',
    supportedFormats: 'Supported: JPG, PNG, PDF (max 10MB/file)',
    uploading: 'Uploading...',
    uploadFailed: 'Upload failed. Please try again!',
    selectFromList: 'Select from list',
    enterManually: 'Enter manually',
    selected: 'Selected',
    selectCountry: 'Select country',
    vietnam: 'Vietnam',
    southKorea: 'South Korea',
    selectVisaType: 'Select visa type',
    visaE9: 'E9 - General Worker',
    visaE7: 'E7 - Special Skills',
    visaF4: 'F4 - Overseas Korean',
    visaF5: 'F5 - Permanent Resident',
    fillRequired: 'Please fill all required fields (name, phone, country, visa type)',
    searchByNamePhone: 'Search by name, phone...',
    enterManuallyBtn: 'Enter manually',
    fullNameLabel: 'Full Name',
    phoneLabel: 'Phone Number',
    emailLabel: 'Email',
    idNumberLabel: 'ID Number',
    countryLabel: 'Country',
    visaTypeLabel: 'Visa Type',
    namePlaceholder: 'John Doe',
    phonePlaceholder: '+84 912 345 678',
    emailPlaceholder: 'email@example.com',
    idPlaceholder: '001234567890',
    selectVisaTypePlaceholder: 'Select visa type',
    countryUSA: 'USA',
    countryChina: 'China',
    countryJapan: 'Japan',
    countryThailand: 'Thailand',
    countryPhilippines: 'Philippines',
    countryIndonesia: 'Indonesia',
    countryMalaysia: 'Malaysia',
    countrySingapore: 'Singapore',
    countryOther: 'Other',
    visaH2: 'H2 - Tourist/Vacation',
    visaF6: 'F6 - Marriage',
    visaD2: 'D2 - Student',
    visaD10: 'D10 - Job Seeker',
    visaCitizen: 'Korean Citizen',
    visaOther: 'Other',
    paymentDateMonthly: 'Monthly payment date',
    notePaymentDate: 'Note',
    notePaymentDateItem1: 'Choose payment date suitable for customer financial capacity',
    notePaymentDateItem2: 'Common dates: 5, 10, 15, 20, 25 of each month',
    selectPaymentDate: 'Please select payment date to continue',
    loanSummary: 'Loan Summary',
    customerLabel: 'Customer',
    phoneLabel: 'Phone',
    idLabel: 'ID',
    bankLabel: 'Bank',
    branchLabel: 'Branch',
    loanAmountLabel: 'Loan Amount',
    termLabel: 'Term',
    interestDateLabel: 'Interest Date',
    principalDateLabel: 'Principal Date',
    dayOfMonth: 'Day',
    monthly: 'monthly',
    notEntered: 'Not entered',
    notSelected: 'Not selected',
    notesOptional: 'Notes (optional)',
    notesPlaceholder: 'Add notes about customer, loan conditions, or other information...',
    notesExample: 'Example: Customer needs urgent loan, stable income, borrowed once before...',
    loanComplete: 'Loan application is complete! You can save as draft or submit now.',
    noCustomerFound: 'No customer found',
    documentsAttached: 'Documents Attached',
    fileCount: 'file',
    estimatedCommissionLabel: 'Estimated Commission',
    estimatedPercent: '(Estimated 2%)',

    // Coming Soon Page
    comingSoonTitle: 'Coming Soon',
    comingSoonDescription: 'This feature is currently under development. Please contact admin for more information.',
    contactUs: 'Contact Us',
    chatViaKakao: 'Chat via KakaoTalk',
    callAdmin: 'Call Admin',
    backToHome: 'Back to Home',

    // Settings Page
    logoutConfirm: 'Logout?',
    ctvRole: 'Collaborator (CTV)',
    userCode: 'Code',
    accountSection: 'Account',
    appSection: 'Application',
    languageLabel: 'Language',
    selectLanguage: 'Select Language',
    appVersion: 'Version',
    appCopyright: '© 2024 CTV Credit',
    notificationEnabled: 'Notifications enabled',
    notificationEnabledBody: 'You will receive notifications about new updates',

    // Step3 Amount
    loanAmountInput: 'Loan Amount',
    quickSelect: 'Quick Select',
    estimatedCommission: 'Estimated Commission',
    monthlyFixed: 'Monthly fixed commission - varies by admin settings',
    minimumLoan: 'Minimum Loan',
    million: 'M',

    // Step2 Bank
    bankLabel: 'Bank',
    branchLabel: 'Branch',
    selectBank: 'Select bank',
    selectBranch: 'Select branch',
    searchBank: 'Search bank...',
    searchBranch: 'Search branch...',
    pleaseSelectBank: 'Please select a bank to continue',
    pleaseSelectBranch: 'Please select a branch to continue',
    bankSelected: 'Bank selected',
    noBranchesAvailable: 'No branches available',
    bankAndBranchSelected: 'Bank and branch selected',
    noBanksFound: 'No banks found',
    noBranchesFound: 'No branches found',
    skipBranchSelection: 'Skip (No branch)',

    // Step4 Term
    termLabel: 'Term',
    monthsLabel: 'months',
    feeRate: 'Fee Rate',
    noteLabel: 'Note',
    estimatedFee: 'Estimated Fee',
    estimatedMonthlyPayment: 'Est. Monthly Payment',
    basedOnInterestRate: 'Based on 12% annual interest rate',
    pleaseEnterTerm: 'Please enter loan term',

    // Step5 Dates - Additional
    selectDate: 'Select date...',
    dayOfMonthLabel: 'Day {day} of month',
    popularDays: 'Popular days',
    dayLabel: 'Day {day}',

    // Step1 Upload - Additional
    uploadAtLeastOne: 'You need to upload at least 1 file to continue',

    // Loan Increase Request Modal
    loanIncreaseRequestTitle: 'Loan Change Request',
    changeMultipleHint: 'You can change one or more items at once',
    changeTypeLabel: 'Change Type',
    changeTypeAmount: 'Change Loan Amount',
    changeTypeTerm: 'Change Loan Term',
    changeTypePaymentDate: 'Change Interest Payment Date',
    loanCodeLabel: 'Loan Code',

    // Amount change
    currentAmountLabel: 'Current Amount',
    newAmountLabel: 'New Loan Amount Request',
    newAmountPlaceholder: 'Enter new loan amount',
    increaseLabel: 'Increase',
    decreaseLabel: 'Decrease',

    // Term change
    currentTermLabel: 'Current Term',
    newTermLabel: 'New Term Request',
    newTermPlaceholder: 'Enter new term',
    termUnit: 'months',
    termChange: 'Change',

    // Payment date change
    currentPaymentDateLabel: 'Current Payment Date',
    newPaymentDateLabel: 'New Payment Date',
    newPaymentDatePlaceholder: 'Enter day (1-28)',
    paymentDateChange: 'Change',

    reasonLabel: 'Reason (optional)',
    reasonPlaceholder: 'Describe reason for the change...',
    submitting: 'Submitting...',
    submitRequest: 'Submit Request',
    errorAtLeastOneChange: 'At least one change is required',
    errorAmountMustDiffer: 'Requested amount must differ from current amount',
    errorTermMustDiffer: 'Requested term must differ from current term',
    errorPaymentDateMustDiffer: 'Requested payment date must differ from current date',
    errorPaymentDateRange: 'Payment date must be between 1 and 28',
    errorCannotSubmit: 'Cannot submit request. Please try again.',

    // Loan Increase Request List
    increaseRequestHistory: 'Change Request History',
    requestedAmountLabel: 'Requested Amount',
    rejectionReasonLabel: 'Rejection Reason',
    approvedAtLabel: 'Accepted at',
    statusPending: 'Pending',
    statusApproved: 'Accepted',
    statusRejected: 'Rejected',

    // Loan Increase Request - Buttons & Success
    requestLoanChange: 'Request Loan Change',
    changeRequestSuccess: 'Change request submitted successfully!',
  },

  ko: {
    // Common
    hello: '안녕하세요',
    loading: '로딩 중...',
    save: '저장',
    cancel: '취소',
    delete: '삭제',
    edit: '수정',
    add: '추가',
    search: '검색',
    filter: '필터',
    close: '닫기',
    confirm: '확인',
    back: '뒤로',
    next: '다음',
    submit: '제출',
    saveDraft: '임시저장',
    success: '성공',
    error: '오류',

    // Auth
    login: '로그인',
    logout: '로그아웃',
    username: '사용자명',
    password: '비밀번호',
    changePassword: '비밀번호 변경',

    // Bottom Nav
    home: '홈',
    work: '업무',
    notifications: '알림',
    settings: '설정',
    profile: '프로필',

    // Profile Page
    accountInfo: '계정 정보',
    fullName: '이름',
    email: '이메일',
    phone: '전화번호',
    userType: '계정 유형',
    joinDate: '가입일',
    actions: '작업',
    language: '언어',
    logout: '로그아웃',
    confirmLogout: '로그아웃 하시겠습니까?',
    collaborator: '협력자',
    administrator: '관리자',
    user: '사용자',
    selectLanguage: '언어 선택',
    notificationEnabled: '알림 활성화됨',
    notificationEnabledBody: '앱에서 알림을 받게 됩니다',
    pleaseSelectImageFile: '이미지 파일을 선택하세요',
    updateSuccessful: '업데이트 성공',
    avatarUpdated: '프로필 사진이 업데이트되었습니다',

    // Services
    loanService: '신용 대출',
    studyAbroadService: '유학',
    creditCardService: '신용카드',
    visaService: '비자 서비스',
    simService: 'SIM 등록',
    phoneService: '휴대폰 구매',
    flightService: '항공권',
    comingSoon: '곧 출시',
    active: '활성',

    // Info page
    info: '정보',
    infoDocuments: '문서',

    // Dashboard
    commissionThisMonth: '이번 달 수수료',
    newCustomers: '신규 고객',
    totalLoans: '총 대출',
    approvedLoans: '접수됨',
    approvalRate: '승인율',

    // Customer
    customers: '고객',
    customerName: '고객명',
    phone: '전화번호',
    email: '이메일',
    address: '주소',
    idNumber: '신분증 번호',
    idType: '신분증 유형',
    dateOfBirth: '생년월일',
    country: '국가',
    notes: '메모',

    // Loan
    createLoan: '대출 신청',
    loanList: '대출 목록',
    loanDetails: '대출 상세',
    loanAmount: '대출 금액',
    loanTerm: '대출 기간',
    months: '개월',
    bank: '은행',
    branch: '지점',
    interestPaymentDate: '이자 납부일',
    principalPaymentDate: '원금 납부일',
    status: '상태',

    // Loan statuses
    pending: '대기 중',
    approved: '접수됨',
    rejected: '거부됨',
    disbursed: '지급됨',
    repaying: '상환 중',
    completed: '완료',
    draft: '임시저장',

    // Commission
    commission: '수수료',
    commissionDetails: '수수료 상세',
    totalCommission: '총 수수료',
    earned: '획득',
    pending: '대기 중',
    clawback: '환수',
    paymentRequest: '지급 요청',
    requestPayment: '지급 요청하기',

    // Notifications
    newLoanApproved: '접수됨',
    loanRejected: '대출 거부됨',
    loanDisbursed: '대출 지급됨',
    commissionPaid: '수수료 지급됨',
    clawbackNotice: '환수 알림',
    noNotifications: '알림 없음',
    markAllRead: '모두 읽음으로 표시',
    all: '전체',
    unread: '읽지 않음',
    read: '읽음',
    justNow: '방금',
    minutesAgo: '분 전',
    hoursAgo: '시간 전',
    daysAgo: '일 전',

    // Login
    loginTitle: 'Link To KMO',
    loginSubtitle: '계속하려면 로그인하세요',
    emailOrPhonePlaceholder: '이메일 또는 전화번호',
    rememberMe: '로그인 상태 유지',
    loggingIn: '로그인 중...',
    contactAdmin: '비밀번호를 잊으셨다면 관리자에게 문의하세요',

    // Work Page
    createNewLoan: '대출 신청',
    createNewLoanDesc: '고객을 위한 새 대출 신청서 작성',
    loanListDesc: '제출 및 임시저장된 신청서 보기',
    customersDesc: '고객 관리',
    commissionDesc: '수수료 확인 및 지급 요청',
    quickOverview: '빠른 개요',
    draftLoans: '임시저장',
    pendingApproval: '승인 대기',
    disbursedLoans: '지급됨',

    // Loan Form
    editLoan: '대출 수정',
    createNewLoanTitle: '새 대출 신청',
    uploadDocuments: '서류 업로드',
    selectBank: '은행 선택',
    loanAmountStep: '대출 금액',
    loanTermStep: '대출 기간',
    paymentDates: '상환일',
    customerInfo: '고객',
    notesStep: '메모',
    continue: '계속',
    savingDraft: '저장 중...',
    sending: '전송 중...',
    sendLoan: '신청서 제출',
    incompleteStep: '미완료',
    scrollDown: '모두 보려면 아래로 스크롤',
    fillAllFields: '계속하기 전에 모든 필수 항목을 입력하세요',
    checkInfo: '정보를 확인하세요',
    confirmSend: '이 대출 신청서를 제출하시겠습니까?',
    draftSaved: '임시저장이 업데이트되었습니다!',
    draftSavedNew: '임시저장되었습니다!',
    loanSentSuccess: '대출 신청이 성공적으로 제출되었습니다! 관리자 승인 대기 중입니다.',
    errorOccurred: '오류가 발생했습니다. 다시 시도해주세요!',

    // Loan List
    loanRecords: '대출 기록',
    createNew: '새로 만들기',
    submitted: '제출됨',
    noLoansSubmitted: '제출된 대출이 없습니다',
    noDrafts: '임시저장된 대출이 없습니다',
    loanCode: '대출',
    rejectionReason: '사유',
    confirmDeleteDraft: '삭제 확인',
    deleteDraftMessage: '이 임시저장 대출을 삭제하시겠습니까?',
    draftDeletedSuccessfully: '임시저장 대출이 성공적으로 삭제되었습니다',

    // Loan Detail
    loanDetail: '대출 상세',
    statusLabel: '상태',
    customerInfoSection: '고객 정보',
    fullName: '성명',
    bankInfoSection: '은행 정보',
    loanInfoSection: '대출 정보',
    createdDate: '생성일',
    disbursedDate: '지급일',
    paymentSchedule: '상환 일정',
    scheduleAfterDisburse: '상환 일정은 지급 후 생성됩니다',
    totalPrincipal: '총 원금',
    totalInterest: '총 이자',
    paidPeriods: '납부 완료',
    period: '기간',
    principal: '원금',
    interest: '이자',
    total: '합계',
    paymentPeriod: '상환 기일',
    expectedInterest: '예상 이자 납부액',
    interestPayment: '예상 이자 납부액',
    principalPayment: '원금 납부액',
    totalPayment: '총 납부액 (원금 + 이자)',
    remainingBalance: '납부 후 잔액',
    paid: '납부 완료',
    unpaid: '미납',
    notFound: '대출을 찾을 수 없습니다',
    backToList: '목록으로 돌아가기',

    // Customer
    addCustomer: '새 고객 추가',
    editCustomer: '고객 수정',
    searchCustomer: '이름, 전화번호, ID로 검색...',
    noCustomersFound: '고객을 찾을 수 없습니다',
    noCustomersYet: '아직 고객이 없습니다. 새 고객을 추가하여 시작하세요!',
    personalInfo: '개인 정보',
    idTypeLabel: 'ID 유형',
    idNumberLabel: 'ID 번호',
    dateOfBirthLabel: '생년월일',
    gender: '성별',
    male: '남성',
    female: '여성',
    other: '기타',
    addressSection: '주소',
    notesSection: '메모',
    deleteCustomer: '이 고객을 삭제하시겠습니까?',
    deleting: '삭제 중...',
    updating: '업데이트 중...',
    creating: '생성 중...',
    update: '업데이트',
    create: '생성',
    customerUpdated: '고객이 성공적으로 업데이트되었습니다!',
    customerCreated: '고객이 성공적으로 생성되었습니다!',
    customerDeleted: '고객이 성공적으로 삭제되었습니다!',
    cannotDelete: '고객을 삭제할 수 없습니다. 다시 시도해주세요!',
    enterName: '성명을 입력하세요',
    enterIdNumber: 'ID 번호를 입력하세요',
    enterPhone: '전화번호를 입력하세요',
    invalidPhone: '유효하지 않은 전화번호',
    invalidEmail: '유효하지 않은 이메일',
    cannotLoadCustomer: '고객 정보를 불러올 수 없습니다',

    // Commission
    commissionPage: '수수료',
    selectPeriod: '기간 선택',
    month: '월',
    totalEarned: '총 수익',
    totalClawback: '환수',
    totalPaid: '지급 완료',
    netAmount: '순액',
    commissionsEarned: '획득한 수수료',
    clawbacks: '환수',
    noCommissionThisMonth: '이번 달 수수료가 없습니다',
    commissionPercent: '비율',
    originalCommission: '원래 수수료',
    clawbackReason: '환수 사유',
    loadingCommission: '수수료 로딩 중...',

    // Payment Request
    paymentRequestTitle: '지급 요청',
    currentMonthCommission: '수수료',
    totalReceivable: '총 수령액',
    createPaymentRequest: '지급 요청 생성',
    withdrawalAmount: '현재 잔액',
    withdrawalAmountLabel: '출금 금액',
    bankName: '은행 이름',
    accountNumber: '계좌 번호',
    accountHolderName: '예금주명',
    enterAmount: '금액 입력',
    enterBankName: '은행 이름 입력',
    enterAccountNumber: '계좌 번호 입력',
    enterAccountHolderName: '예금주명 입력',
    totalAvailable: '출금 가능 금액',
    requestedAmount: '출금 요청 금액',
    enterRequestedAmount: '출금 요청 금액 입력',
    maxAmount: '최대',
    invalidWithdrawalAmount: '출금 금액이 유효하지 않거나 잔액을 초과합니다',
    pleaseCompleteAllFields: '모든 필드를 입력하세요',
    submitRequest: '요청 제출',
    requestHistory: '요청 내역',
    noRequestsYet: '아직 지급 요청이 없습니다',
    requestCreated: '생성일',
    requestApproved: '승인일',
    requestPaid: '지급일',
    noCommissionToRequest: '요청할 수수료가 없습니다',
    confirmPaymentRequest: '지급 요청을 생성하시겠습니까',
    requestSuccess: '지급 요청이 성공적으로 생성되었습니다!\n관리자가 곧 검토하고 승인할 것입니다.',
    noCommissionYet: '이번 달 수수료가 없습니다',
    negativeCommission: '환수로 인해 수수료가 마이너스입니다. 요청을 생성할 수 없습니다.',
    note: '참고',
    noteItem1: '지급 요청은 3-5 영업일 이내에 관리자가 검토합니다',
    noteItem2: '수수료는 승인 후 등록된 계좌로 이체됩니다',
    noteItem3: '환수가 있는 경우 금액이 자동으로 차감됩니다',
    noteItem4: '"수수료" 페이지에서 수수료 세부 정보를 확인할 수 있습니다',

    // HomePage
    recentActivity: '최근 활동',
    newCustomersCount: '신규 고객',
    approvedCount: '접수됨',
    loanRecordsLabel: '대출',
    commissionLabel: '수수료',
    customersLabel: '고객',

    // Step Components
    uploadFiles: '서류 업로드',
    clickOrDrag: '파일을 선택하거나 여기에 드래그하세요',
    supportedFormats: '지원: JPG, PNG, PDF (최대 10MB/파일)',
    uploading: '업로드 중...',
    uploadFailed: '업로드 실패. 다시 시도해주세요!',
    selectFromList: '목록에서 선택',
    enterManually: '수동 입력',
    selected: '선택됨',
    selectCountry: '국가 선택',
    vietnam: '베트남',
    southKorea: '대한민국',
    selectVisaType: '비자 유형 선택',
    visaE9: 'E9 - 일반 근로자',
    visaE7: 'E7 - 특별 기술',
    visaF4: 'F4 - 재외동포',
    visaF5: 'F5 - 영주권',
    fillRequired: '필수 항목을 모두 입력하세요 (이름, 전화번호, 국가, 비자 유형)',
    searchByNamePhone: '이름, 전화번호로 검색...',
    enterManuallyBtn: '수동 입력',
    fullNameLabel: '성명',
    phoneLabel: '전화번호',
    emailLabel: '이메일',
    idNumberLabel: 'ID 번호',
    countryLabel: '국가',
    visaTypeLabel: '비자 유형',
    namePlaceholder: '홍길동',
    phonePlaceholder: '+84 912 345 678',
    emailPlaceholder: 'email@example.com',
    idPlaceholder: '001234567890',
    selectVisaTypePlaceholder: '비자 유형 선택',
    countryUSA: '미국 (USA)',
    countryChina: '중국 (China)',
    countryJapan: '일본 (Japan)',
    countryThailand: '태국 (Thailand)',
    countryPhilippines: '필리핀',
    countryIndonesia: '인도네시아',
    countryMalaysia: '말레이시아',
    countrySingapore: '싱가포르',
    countryOther: '기타',
    visaH2: 'H2 - 관광/휴가',
    visaF6: 'F6 - 결혼',
    visaD2: 'D2 - 유학',
    visaD10: 'D10 - 구직',
    visaCitizen: '한국 시민',
    visaOther: '기타',
    paymentDateMonthly: '월별 상환일',
    notePaymentDate: '참고',
    notePaymentDateItem1: '고객의 재정 능력에 맞는 상환일을 선택하세요',
    notePaymentDateItem2: '일반적인 날짜: 매월 5, 10, 15, 20, 25일',
    selectPaymentDate: '계속하려면 상환일을 선택하세요',
    loanSummary: '대출 요약',
    customerLabel: '고객',
    phoneLabel: '전화번호',
    idLabel: 'ID',
    bankLabel: '은행',
    branchLabel: '지점',
    loanAmountLabel: '대출 금액',
    termLabel: '기간',
    interestDateLabel: '이자 납부일',
    principalDateLabel: '원금 납부일',
    dayOfMonth: '일',
    monthly: '매월',
    notEntered: '입력되지 않음',
    notSelected: '선택되지 않음',
    notesOptional: '메모 (선택사항)',
    notesPlaceholder: '고객, 대출 조건 또는 기타 정보에 대한 메모 추가...',
    notesExample: '예: 고객이 긴급 대출 필요, 안정적인 수입, 이전에 한 번 대출...',
    loanComplete: '대출 신청이 완료되었습니다! 임시저장하거나 지금 제출할 수 있습니다.',
    noCustomerFound: '고객을 찾을 수 없습니다',
    documentsAttached: '첨부 서류',
    fileCount: '파일',
    estimatedCommissionLabel: '예상 수수료',
    estimatedPercent: '(예상 2%)',

    // Coming Soon Page
    comingSoonTitle: '곧 출시 예정',
    comingSoonDescription: '이 기능은 현재 개발 중입니다. 더 자세한 정보가 필요하시면 관리자에게 문의해 주세요.',
    contactUs: '문의하기',
    chatViaKakao: '카카오톡으로 문의',
    callAdmin: '전화 문의',
    backToHome: '홈으로 돌아가기',

    // Settings Page
    logoutConfirm: '로그아웃하시겠습니까?',
    ctvRole: '협력자 (CTV)',
    userCode: '코드',
    accountSection: '계정',
    appSection: '애플리케이션',
    languageLabel: '언어',
    selectLanguage: '언어 선택',
    appVersion: '버전',
    appCopyright: '© 2024 CTV 신용',
    notificationEnabled: '알림 활성화됨',
    notificationEnabledBody: '새로운 업데이트에 대한 알림을 받게 됩니다',

    // Step3 Amount
    loanAmountInput: '대출 금액',
    quickSelect: '빠른 선택',
    estimatedCommission: '예상 수수료',
    monthlyFixed: '월별 고정 수수료 - 관리자 설정에 따라 다름',
    minimumLoan: '최소 대출 금액',
    million: '백만',

    // Step2 Bank
    bankLabel: '은행',
    branchLabel: '지점',
    selectBank: '은행 선택',
    selectBranch: '지점 선택',
    searchBank: '은행 검색...',
    searchBranch: '지점 검색...',
    pleaseSelectBank: '은행을 선택해주세요',
    pleaseSelectBranch: '지점을 선택해주세요',
    bankSelected: '은행이 선택되었습니다',
    noBranchesAvailable: '지점 정보가 없습니다',
    bankAndBranchSelected: '은행과 지점이 선택되었습니다',
    noBanksFound: '은행을 찾을 수 없습니다',
    noBranchesFound: '지점을 찾을 수 없습니다',
    skipBranchSelection: '건너뛰기 (지점 없음)',

    // Step4 Term
    termLabel: '기간',
    monthsLabel: '개월',
    feeRate: '수수료율',
    noteLabel: '비고',
    estimatedFee: '예상 수수료',
    estimatedMonthlyPayment: '월 상환액 예상',
    basedOnInterestRate: '예상 이자율 12%/년 기준',
    pleaseEnterTerm: '대출 기간을 입력해주세요',

    // Step5 Dates - Additional
    selectDate: '날짜 선택...',
    dayOfMonthLabel: '매월 {day}일',
    popularDays: '인기 날짜',
    dayLabel: '{day}일',

    // Step1 Upload - Additional
    uploadAtLeastOne: '계속하려면 최소 1개의 파일을 업로드해야 합니다',

    // Loan Increase Request Modal
    loanIncreaseRequestTitle: '대출 변경 요청',
    changeMultipleHint: '한 번에 하나 이상의 항목을 변경할 수 있습니다',
    changeTypeLabel: '변경 유형',
    changeTypeAmount: '대출 금액 변경',
    changeTypeTerm: '대출 기간 변경',
    changeTypePaymentDate: '이자 납부일 변경',
    loanCodeLabel: '대출 코드',

    // Amount change
    currentAmountLabel: '현재 금액',
    newAmountLabel: '새로운 대출 금액 요청',
    newAmountPlaceholder: '새로운 대출 금액 입력',
    increaseLabel: '증가',
    decreaseLabel: '감소',

    // Term change
    currentTermLabel: '현재 기간',
    newTermLabel: '새로운 기간 요청',
    newTermPlaceholder: '새로운 기간 입력',
    termUnit: '개월',
    termChange: '변경',

    // Payment date change
    currentPaymentDateLabel: '현재 납부일',
    newPaymentDateLabel: '새로운 납부일',
    newPaymentDatePlaceholder: '날짜 입력 (1-28)',
    paymentDateChange: '변경',

    reasonLabel: '사유 (선택사항)',
    reasonPlaceholder: '변경 사유를 설명해주세요...',
    submitting: '제출 중...',
    submitRequest: '요청 제출',
    errorAtLeastOneChange: '최소 하나의 변경 사항이 필요합니다',
    errorAmountMustDiffer: '요청 금액은 현재 금액과 달라야 합니다',
    errorTermMustDiffer: '요청 기간은 현재 기간과 달라야 합니다',
    errorPaymentDateMustDiffer: '요청 납부일은 현재 납부일과 달라야 합니다',
    errorPaymentDateRange: '납부일은 1에서 28 사이여야 합니다',
    errorCannotSubmit: '요청을 제출할 수 없습니다. 다시 시도해주세요.',

    // Loan Increase Request List
    increaseRequestHistory: '변경 요청 내역',
    requestedAmountLabel: '요청 금액',
    rejectionReasonLabel: '거부 사유',
    approvedAtLabel: '접수 시간',
    statusPending: '대기 중',
    statusApproved: '접수됨',
    statusRejected: '거부됨',

    // Loan Increase Request - Buttons & Success
    requestLoanChange: '대출 변경 요청',
    changeRequestSuccess: '변경 요청이 성공적으로 제출되었습니다!',
  },
};

export const t = (key, lang = 'vi') => {
  return translations[lang]?.[key] || key;
};

export const useTranslation = (language = 'vi') => {
  return {
    t: (key) => t(key, language),
    language,
  };
};

export default translations;
